import { defineStore } from "pinia";
import { getCardTemplates } from "@/api/statics.js";

export const useCardTemplatesStore = defineStore("cardTemplates", {
  state: () => ({
    templates: []
  }),
  actions: {
    setTemplates(templates) {
      this.templates = templates;
    },
    async getCardTemplates() {
      const res = await getCardTemplates();
      if (res?.data) {
        this.setTemplates(res.data.results);
      }
      return res;
    }
  },
  persist: {
    key: "cardTemplates",
    storage: sessionStorage,
    pick: ["templates"]
  }
});

export default useCardTemplatesStore;
